/*
  NOTE: We can access the content of the popup programatically
  after it has opened or closed via the custom events that are
  emitted ('popup:open', 'popup:close'). To get the content of
  the data after a popup is opened you would do the following:

  $(document).on('popup:open', function(e) {
    var $popupContent = $(e.target);

    // do stuff with $popupContent
  });

  You can do this from any JS file or block. It doesnt have
  to be contained in this file.
*/
/*
  NOTE: There are several ways to trigger a popup.
  1) Create a div on the page with the ID 'popup_[something]'.
     It will be hidden by default. Trigger it by clicking on
     an element with the following attribute:
     'data-popup-trigger="popup_[something]"'
  2) Create the same div as step 1, but trigger the popup
     dymanically by calling the function triggerPopup() and
     passing an options object like this:
     triggerPopup({hash: '#popup_[something]'});
  3) You can also use the triggerPopup() function to dynamically
     create a popup by passing HTML like this:
     triggerPopup({data: '<p>I'm a popup</p>'});
  4) A popup that exists on the page (see #1) can be called as
     a call back to another popup (i.e. opened after the 1st popup
     closes. Open a popup via methods 2 or 3 and pass the ID of an
     existing popup on the page as a second parameter to the
     triggerPopup() function like this:
     triggerPopup({callbackPopup: '#popup_[somethingElse]'});
  5) You can also create a callback popup by passing HTML to the
     triggerPopup() function like this:
     triggerPopup({callbackPopupData: '<p>I'm a callback popup</p>'});
*/
/*
  NOTE: Triggers that exist on the page (see #1 above) have several
  optional parameters:
  1) data-width="integer":
     Set the display width of this specific popup (will never be
     more than 100% of the viewport). It applies only to instances
     of the popup opened by this triger.
  2) data-target="url"
     For use in interstitial popups. Set a url to open in a new
     tab after popup displays. (Popup must contain an <a> tag with
     the class externalLink). This would be useful to have multiple
     triggers that point to different external URL's that all make
     use of the same popup.
  3) data-callback-popup="ID"
     Similar to #4 above, you can pass the ID of another popup to
     be opened when the current popup is closed.
  4) data-callback-popup-data="HTML"
     Similar to #5 above, you can pass some HTML to be opened as a
     popup when the current popup is closed.
*/
/*
  NOTE: Popups that exist on the page (see #1 above) have an optional
  parameter:
  1) data-width="integer":
     Set the display width of this specific popup (will never be
     more than 100% of the viewport). It applies to all instances
     of this popup.
*/
/************************************
 ****** Trigger Popup By Click  ******
 ************************************/
$(document).on('click', '[data-popup-trigger]', function (e) {
  e.stopImmediatePropagation()
  e.stopPropagation()
  e.preventDefault()
  var $this = $(e.target).closest('[data-popup-trigger]')
  var hash = $this.attr('data-popup-trigger')
  var keyboard = false

  if (e.screenX == 0 && e.screenY == 0) {
    keyboard = true
  }

  triggerPopup({
    hash: hash,
    trigger: $this,
    keyboard: keyboard,
  })
})

/************************************
 ** Trigger Popup Programmatically  **
 ************************************/
function triggerPopup(params) {
  /* ----------------------------------
  ----- Process Options ---------------
  ---------------------------------- */
  var defaults = {
    hash: '',
    data: '',
    callbackPopup: '',
    callbackPopupData: '',
    trigger: '',
    keyboard: false,
  }
  var options = $.extend({}, defaults, params)
  /* ----------------------------------
  ----- Close Existing Popups ---------
  ---------------------------------- */
  if ($('.popup').length) {
    $('.popup').find('.popup-close').click()
  }
  /* ----------------------------------
  ----- Variables ---------------------
  ---------------------------------- */
  var $trigger = $(options.trigger)
  var keyboard = options.keyboard
  var $data
  var onPage = false
  if (options.data === '') {
    $data = $(options.hash)
    onPage = true
  } else {
    $data = $(options.data)
  }

  var $placeholder = $('<placeholder />').hide()
  var $popup = $('<div class="popup" />').hide()
  var $overlay = $('<div class="popup-overlay" />')
  var $content = $('<div class="popup-content" />')
  var $close = $('<div class="popup-close" tabindex="0"></div>')

  const handleKeydownEventsCallback = (e) => {
    const isTab = e.key.toLowerCase() === 'tab'

    if (!isTab) return

    const focusableElements = 'a, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    const focusElements = [...$content[0].querySelectorAll(focusableElements)]
    const firstElement = focusElements[0]
    const lastElement = focusElements[focusElements.length - 1]

    if (e.target === firstElement && e.shiftKey) {
      e.preventDefault()
      lastElement && lastElement.focus()
    }

    if (e.target === lastElement) {
      if (e.shiftKey) return

      e.preventDefault()
      firstElement && firstElement.focus()
    }
  }

  /* ----------------------------------
  ----- Local Functions ---------------
  ---------------------------------- */
  function openPopup() {
    var open = $.Event('popup:open', { target: $content })

    $popup.on('popup:open', function (event) {
      if (onPage) $data.before($placeholder)

      $content.append($close).append($data)
      $overlay.append($content)
      $content[0].setAttribute('tabindex', '0')

      $(this).append($overlay)
      $('.pageWrap').addClass('is-blurred')
      $('html').addClass('no-scroll')
      $('html').addClass('popup-open')
      $(this).fadeIn(250)

      // focus trap accessibility
      const modalWrapper = $content[0]
      modalWrapper && modalWrapper.focus()

      window.addEventListener('keydown', handleKeydownEventsCallback)
    })

    $('.pageWrap').after($popup)
    $popup.trigger(open)
  }

  function closePopup() {
    var close = $.Event('popup:close', { target: $content })
    $popup.on('popup:close', function () {
      $popup.fadeOut(250, function () {
        if (onPage) {
          $placeholder.after($data)
          $placeholder.remove()
        }

        $popup.remove()

        if (options.callbackPopup !== '') {
          triggerPopup({
            hash: options.callbackPopup,
          })
        } else if (options.callbackPopupData !== '') {
          triggerPopup({
            data: options.callbackPopupData,
          })
        } else if ($trigger.length && $trigger.is('[data-callback-popup]')) {
          triggerPopup({
            hash: $trigger.attr('data-callback-popup'),
          })
        } else if ($trigger.length && $trigger.is('[data-callback-popup-data]')) {
          triggerPopup({
            data: $trigger.attr('data-callback-popup-data'),
          })
        }
      })

      // focus trap teardown
      $content[0].setAttribute('tabindex', '-1')
      window.removeEventListener('keydown', handleKeydownEventsCallback)

      $('.pageWrap').removeClass('is-blurred')
      $('html').removeClass('no-scroll')
      $('html').removeClass('popup-open')
    })

    $popup.trigger(close)
  }
  /* ----------------------------------
  ----- Set Specific Width ------------
  ---------------------------------- */
  if ($data.is('[data-width]')) {
    $content.css('width', $data.attr('data-width'))
  }
  if ($trigger.length && $trigger.is('[data-width]')) {
    $content.css('width', $trigger.attr('data-width'))
  }
  /* ----------------------------------
  ----- Set External Link -------------
  ---------------------------------- */
  if ($trigger.length && $trigger.is('[data-target]')) {
    var $exitLink = $data.find('.externalLink')
    $exitLink
      .attr('href', $trigger.attr('data-target'))
      .attr('target', '_blank')
      .click(function () {
        closePopup()
      })
  }
  /* ----------------------------------
  ----- Popup Interactions ------------
  ---------------------------------- */
  if ($data.find('.js-closePopup').length) {
    $data.find('.js-closePopup').click(function (e) {
      e.preventDefault()
      closePopup()
      if (e.screenX == 0 && e.screenY == 0 && $trigger.length) {
        $trigger.attr('tabindex', 0).focus()
      }
    })
  }
  $close.click(function () {
    closePopup()
  })
  $close.keypress(function (e) {
    if (e.which == 13) {
      closePopup()
      if ($trigger.length) {
        $trigger.attr('tabindex', 0).focus()
      }
    }
  })
  $overlay.click(function (e) {
    var $target = $(e.target)
    if (!$target.closest('.popup-content').length) {
      closePopup()
    }
  })
  openPopup()
}
